import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class PriceChangesFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
    } = this.props;

    return (
      <div className="filters-container admin-priceChanges-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Is Addon:</label>
            <Select name="type" options={['yes', 'no']} selectLabel="-" emptyOption/>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default PriceChangesFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChangeFilters/PriceChangeFilters.view.js